import i18n from '../i18n';

export const REFETCH_BUTTON_ID = 'mail-folder-refetch-button';
export const OUT_OF_SYNC_CLASSNAME = 'out-of-sync';

const SLEEP_THRESHOLD_MS = 30 * 60 * 1000; // 30 minutes

class WindowSleepManager {
  private lastTimeAwake: Date | null = null;
  private outOfSync: boolean = false;

  constructor() {
    this.lastTimeAwake = new Date();
    this.bindEvents();
  }

  private bindEvents() {
    window.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocus);
  }

  private handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible') {
      this.handleLastTimeAwake();
    }
  };

  private handleWindowFocus = () => {
    this.handleLastTimeAwake();
  };

  /**
   * Checks if the window has been inactive for longer than the threshold
   * and triggers out of sync if necessary.
   * @param threshold in ms
   */
  handleLastTimeAwake(threshold: number = SLEEP_THRESHOLD_MS) {
    if (this.lastTimeAwake) {
      const now = new Date();
      const timeDiff = now.getTime() - this.lastTimeAwake.getTime();
      if (timeDiff > threshold) {
        this.triggerOutOfSync();
      }
    }
    this.updateLastTimeAwake();
  }

  updateLastTimeAwake() {
    this.lastTimeAwake = new Date();
  }

  triggerOutOfSync() {
    this.outOfSync = true;
    try {
      const elements = document.getElementsByClassName(REFETCH_BUTTON_ID);
      if (elements) {
        for (const reloadButtonElement of Array.from(elements)) {
          if (reloadButtonElement) {
            if (
              !reloadButtonElement.classList.contains(OUT_OF_SYNC_CLASSNAME)
            ) {
              reloadButtonElement.classList.add(OUT_OF_SYNC_CLASSNAME);
            }
            (reloadButtonElement as HTMLElement).title = i18n.t(
              'common:mailOutOfSync'
            );
          }
        }
      }
    } catch (error) {
      console.error('Error triggering out of sync event', error);
    }
  }

  isOutOfSync() {
    return this.outOfSync;
  }

  resetOutOfSync() {
    this.outOfSync = false;
    this.updateLastTimeAwake();
    try {
      const elements = document.getElementsByClassName(REFETCH_BUTTON_ID);
      if (elements) {
        for (const reloadButtonElement of Array.from(elements)) {
          if (reloadButtonElement) {
            reloadButtonElement.classList.remove(OUT_OF_SYNC_CLASSNAME);
            reloadButtonElement.removeAttribute('title');
          }
        }
      }
    } catch (error) {
      console.error('Error resetting out of sync event', error);
    }
  }
}

export const WINDOW_SLEEP_MANAGER = new WindowSleepManager();
